import { Card, FC, Link, useMemo } from 'external/react'

import useParent from 'context/parent-context/hook'
import UserCard from './UserCard'
import { User } from 'types/context/parent'
import EditUserModal from './EditUser'

import { notifyError, notifySuccess, showConfirmDialog } from 'components/Notify'
import { capitalizeFirstLetter } from 'utilities/text'
import Icon, { IconName } from 'external/fortawesome'
import { clsx } from 'external/clsx'

const UsersPage:FC = () => {
    const {update, state: {users}, params: {role}, deleteUser, navigation} = useParent()

    function handleEditUser(index: number, user: User) {
        user.index = index
        update({modals: {editUser: {open: {$set: true}, user: {$set: user}}}})
    }
    
    const [roleText, roleIcon, newUserLink] = useMemo(() => (
        (role === 'student')
            ? ['Estudiante', 'faGraduationCap', navigation.newUser.link({role: 'student'})]
            : ['Tutor', 'faPersonChalkboard', navigation.newUser.link({role: 'tutor'})]
        ) as [string, IconName, string], [role])

    
    async function handleDeleteUser(user: User) {
        
        if (user.packages > 0) return notifyError(`No se puede eliminar el ${role === 'student' ? 'estudiante' : 'tutor'}: ${user.name}, si desea hacerlo deberá comunicarse con el equipo de soporte.`)

        const {isConfirmed} = await showConfirmDialog(`¿Está seguro que desea eliminar este ${roleText}?`)
        if (!isConfirmed) return

        const deletionResult = await deleteUser(user.id)
        if (deletionResult !== true) return notifyError(deletionResult)

        return notifySuccess(`${capitalizeFirstLetter(roleText)} eliminado exitosamente.`)
    }

	return (
        <>
        <Card.Body className='mt-2'>
            <div className='row'>
                {users.items.map((user, index) => (
                    <UserCard key={index} user={user} onEditUserClick={user => handleEditUser(index, user)} onDeleteClick={handleDeleteUser} />))}
            </div>
            <EditUserModal />
        </Card.Body>
        <Card.Footer className='py-2 d-flex justify-content-end pl-0'>
            <Link to={newUserLink} style={{ width: '170px' }} className={clsx('language__filter p-2 mt-2 button')}>
                <Icon name={roleIcon} /> Nuevo {roleText}
            </Link>
        </Card.Footer>
        </>
	)
}

export {UsersPage as default}